/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {Injectable} from '@angular/core';
import {of, tap} from 'rxjs';
import {SpatialUtilService} from '../spatial-util.service';
import {switchMap} from 'rxjs/operators';
import {NgEventBus} from 'ng-event-bus';
import {FeatureAssociationService} from './feature-association.service';
import {forkJoinDefaultIfEmpty} from '../../../common/observable.utils';

@Injectable({
    providedIn: 'root'
})
export class LotService {
    title = 'LotService';

    constructor(
        private eventBus: NgEventBus,
        private featureAssociationService: FeatureAssociationService,
        private spatialUtilService: SpatialUtilService
    ) {}

    saveLotAssociation(lotId: number) {
        console.debug(`${this.title} - saveLotAssociation`);

        const lot = this.spatialUtilService.findById('lot', lotId);

        const lotPolygonIds = this.spatialUtilService.parseIdsAttr(lot.attributes.polygonids);
        const lotPolygons = lotPolygonIds.length
            ? this.spatialUtilService.getPolygonGraphics().filter((p: any) => lotPolygonIds.includes(p.attributes.id))
            : [];

        const selectedPolygons = this.spatialUtilService.getHighlightedPolygons();
        const selectedPolygonIds = selectedPolygons.map((p: any) => p.attributes.id);

        return this.featureAssociationService.dissociatePolygonsFromRoads(selectedPolygons.filter((p: any) => p.attributes.roadid)).pipe(
            switchMap(() => {
                const lotPolygonsToDissociate = selectedPolygons.filter((p: any) => p.attributes.lotid && p.attributes.lotid !== lot.attributes.id);
                if (lotPolygonsToDissociate.length) {
                    return forkJoinDefaultIfEmpty(
                        lotPolygonsToDissociate.map((p: any) =>
                            this.featureAssociationService.applyLotDissociation(p.attributes.lotid, p.attributes.id, 'polygon')
                        )
                    );
                }
                return of(null);
            }),
            switchMap(() => {
                const polygonsToBeRemoved = lotPolygons.filter((p: any) => !selectedPolygonIds.includes(p.attributes.id));
                const polygonsToBeAdded = selectedPolygons.filter((p: any) => !lotPolygonIds.includes(p.attributes.id));

                if (polygonsToBeRemoved.length || polygonsToBeAdded.length) {
                    return this.featureAssociationService.updateLotPolygonAssociationChanges(lot, polygonsToBeRemoved, polygonsToBeAdded).pipe(
                        switchMap(() => this.featureAssociationService.updateLotAssociationChanges(lot, polygonsToBeRemoved, polygonsToBeAdded)),
                        tap(() => {
                            if (polygonsToBeRemoved.length > 0) {
                                this.eventBus.cast('deleteAnnotations', {
                                    featureLayer: this.spatialUtilService.getPolygonMapLayer(),
                                    features: polygonsToBeRemoved,
                                    parentFeatureType: 'lot'
                                });
                            }

                            if (polygonsToBeAdded.length > 0) {
                                this.eventBus.cast('createAnnotation', {feature: lot, featureType: 'lot', polygons: polygonsToBeAdded});
                            }

                            return window.setTimeout(() => this.eventBus.cast('updateAnnotation', {feature: lot, featureType: 'lot'}), 500);
                        })
                    );
                }
                return of(null);
            })
        );
    }

    updateLotAreaIfRequired(featuresAfterUpdate: any[], featuresBeforeUpdate: any[]) {
        console.debug(`${this.title} - updateLotAreaIfRequired`);

        const allLots = this.spatialUtilService.getLots();
        const allPolygons = this.spatialUtilService.getPolygons();

        featuresAfterUpdate.forEach((featureAfterUpdate: any) => {
            const featureBeforeUpdate = featuresBeforeUpdate.find(e => e.attributes.id === featureAfterUpdate.attributes.id);

            if (featureBeforeUpdate.attributes.statedarea !== featureAfterUpdate.attributes.statedarea) {
                allLots
                    .filter((l: any) => l.attributes.polygonids && l.attributes.polygonids.includes(`[${featureAfterUpdate.attributes.id}]`))
                    .forEach((l: any) => {
                        const polygons = l.attributes.polygonids
                            ? allPolygons.filter((p: any) => l.attributes.polygonids.includes(`[${p.attributes.id}]`))
                            : [];
                        this.featureAssociationService.setTotalAreaAndGeometry(l, polygons);
                        this.eventBus.cast('updateAnnotation', {feature: l, featureType: 'lot'});
                    });
            }
        });
    }
}
